import { useState } from "react";
import { Star, ChevronDown } from "lucide-react";
import { C, SERIF, SANS } from "../lib/constants";

export function Btn({ children, onClick, variant = "primary", size = "md", full = false, style: sx = {}, ...rest }) {
  const sz = { sm: { padding: "8px 18px", fontSize: 12 }, md: { padding: "12px 26px", fontSize: 13 },
    lg: { padding: "15px 34px", fontSize: 14 } };
  const vr = {
    primary:   { background: C.coral, color: "#fff", border: "none" },
    secondary: { background: "transparent", color: C.dark, border: `1px solid ${C.dark}` },
    white:     { background: "#fff", color: C.dark, border: "none" },
    ghost:     { background: "transparent", color: C.coral, border: "none", padding: 0 },
    soft:      { background: C.coralBg, color: C.coral, border: "none" },
  };
  return (
    <button onClick={onClick} {...rest} style={{ display: "inline-flex", alignItems: "center",
      justifyContent: "center", gap: 8, cursor: "pointer", fontFamily: SANS,
      fontWeight: 600, letterSpacing: 0.3, borderRadius: 4,
      width: full ? "100%" : "auto", ...sz[size], ...vr[variant], ...sx }}>
      {children}
    </button>
  );
}

export function Stars({ n = 5, size = 13 }) {
  return <span style={{ display: "inline-flex", gap: 2 }}>
    {[1, 2, 3, 4, 5].map(i => <Star key={i} size={size}
      fill={i <= n ? C.coral : "none"} stroke={i <= n ? C.coral : C.mutedLt} />)}
  </span>;
}

export function Eyebrow({ children, color = C.muted }) {
  return <div style={{ fontFamily: SANS, fontSize: 10, letterSpacing: 3, color,
    textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>{children}</div>;
}

export function Accordion({ title, content }) {
  const [open, setOpen] = useState(false);
  const id = String(title).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  return (
    <div style={{ borderBottom: `1px solid ${C.border}` }} data-testid={`accordion-${id}`}>
      <button onClick={() => setOpen(!open)} aria-expanded={open} aria-controls={`acc-${id}`}
        data-testid={`accordion-toggle-${id}`} style={{ width: "100%", background: "none",
        border: "none", cursor: "pointer", padding: "16px 0", display: "flex",
        justifyContent: "space-between", alignItems: "center", fontFamily: SANS,
        fontSize: 14, fontWeight: 500, color: C.dark, textAlign: "left" }}>
        {title}
        <ChevronDown size={15} color={C.muted}
          style={{ transform: open ? "rotate(180deg)" : "none", transition: "0.2s", flexShrink: 0 }} />
      </button>
      <div id={`acc-${id}`} role="region" data-testid={`accordion-content-${id}`}
        style={{ display: "grid", gridTemplateRows: open ? "1fr" : "0fr",
          transition: "grid-template-rows 0.25s ease" }}>
        <div style={{ overflow: "hidden" }}>
          <div style={{ paddingBottom: 16, fontFamily: SANS, fontSize: 13,
            color: C.muted, lineHeight: 1.8 }}>{content}</div>
        </div>
      </div>
    </div>
  );
}

export function ImgPh({ h = 300, label = "Photography", r = 14, bg = C.cream }) {
  return <div style={{ background: bg, borderRadius: r, height: h, display: "flex",
    alignItems: "center", justifyContent: "center" }}>
    <span style={{ fontFamily: SANS, fontSize: 12, color: C.mutedLt,
      textAlign: "center", padding: 20 }}>{label}</span>
  </div>;
}
